require("core-js/modules/es.array.sort.js");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.createAutoCorrectedDatePipe = t() : e.createAutoCorrectedDatePipe = t();
}(this, function () {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        exports: {},
        id: n,
        loaded: !1
      };
      return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.p = "", t(0);
  }([function (e, t, r) {
    e.exports = r(1);
  }, function (e, t) {
    "use strict";

    function r() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "mm dd yyyy",
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.minYear,
          i = void 0 === r ? 1 : r,
          d = t.maxYear,
          u = void 0 === d ? 9999 : d,
          s = e.split(/[^dmyHMS]+/).sort(function (e, t) {
        return o.indexOf(e) - o.indexOf(t);
      });
      return function (t) {
        var r = [],
            o = {
          dd: 31,
          mm: 12,
          yy: 99,
          yyyy: u,
          HH: 23,
          MM: 59,
          SS: 59
        },
            d = {
          dd: 1,
          mm: 1,
          yy: 0,
          yyyy: i,
          HH: 0,
          MM: 0,
          SS: 0
        },
            a = t.split("");
        s.forEach(function (t) {
          var n = e.indexOf(t),
              i = parseInt(o[t].toString().substr(0, 1), 10);
          parseInt(a[n], 10) > i && (a[n + 1] = a[n], a[n] = 0, r.push(n));
        });
        var y = 0,
            f = s.some(function (r) {
          var s = e.indexOf(r),
              a = r.length,
              f = t.substr(s, a).replace(/\D/g, ""),
              p = parseInt(f, 10);
          "mm" === r && (y = p || 0);
          var c = "dd" === r ? n[y] : o[r];

          if ("yyyy" === r && (1 !== i || 9999 !== u)) {
            var l = parseInt(o[r].toString().substring(0, f.length), 10),
                m = parseInt(d[r].toString().substring(0, f.length), 10);
            return p < m || p > l;
          }

          return p > c || f.length === a && p < d[r];
        });
        return !f && {
          value: a.join(""),
          indexesOfPipedChars: r
        };
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var n = [31, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        o = ["yyyy", "yy", "mm", "dd", "HH", "MM", "SS"];
  }]);
});